<div class="results-container">
    <div class="header">
        <div class="skeleton skeleton-text skeleton-header"></div>
    </div>
    
    <div class="search-results">
        <!-- Generate multiple skeleton items -->
        <div class="search-result-item skeleton-item" *ngFor="let item of skeletonItems">
            <div class="customer-info">
                <div class="customer-name skeleton skeleton-text skeleton-name"></div>
                <div class="customer-details">
                    <div class="skeleton skeleton-text skeleton-email"></div>
                    <div class="skeleton skeleton-text skeleton-phone"></div>
                </div>
            </div>
            <div class="action-buttons">
                <div class="skeleton skeleton-button"></div>
                <div class="skeleton skeleton-button-small"></div>
            </div>
        </div>
    </div>
</div>